import * as yup from 'yup';
import { customNullable } from "..";

export const PropertyAddressValidationRuleObject = {
    addressPoint: customNullable(yup
        .number())
        // .transform((value, originalValue) => (originalValue?.trim() ?? "") === "" ? null : value)
        .when("isCatastralNumber", {
            is: (onlyLotNumber?: boolean) => (onlyLotNumber ?? false) == false,
            then: () => yup
                .number()
                .nullable()
                .required("Zadejte místo pojištění"),
            otherwise: undefined,
        }),

    streetNumber: yup
        .string()
        .nullable()
        .when("isCatastralNumber", {
            is: (onlyLotNumber?: boolean) => (onlyLotNumber ?? false) == false,
            then: () => yup
                .string()
                .nullable()
                .required("Číslo popisné nebo orientační je povinné"),
            otherwise: undefined,
        }),

    postCodeCu: yup
        .string()
        .nullable()
        .when("isCatastralNumber", {
            is: (onlyLotNumber?: boolean) => (onlyLotNumber ?? false) == true,
            then: () => yup
                .string()
                .nullable()
                .required('PSČ je povinné')
                .length(5, 'PSČ musí mít 5 číslic')
                .matches(/^[0-9]+$/, "PSČ může obsahovat pouze číslice"),
            otherwise: undefined,
        }),

    catastralAreaCode: yup
        .string()
        .nullable()
        .when("isCatastralNumber", {
            is: (onlyLotNumber?: boolean) => (onlyLotNumber ?? false) == true,
            then: () => yup
                .string()
                .nullable()
                .required('Vyberte katastrální území'),
            otherwise: undefined,
        }),

    parcelNumber: yup
        .string()
        .nullable()
        .when("isCatastralNumber", {
            is: (onlyLotNumber?: boolean) => (onlyLotNumber ?? false) == true,
            then: () => yup
                .string()
                .nullable()
                .required('Parcelní číslo je povinné'),
            otherwise: undefined,
        }),
}

export const PropertyAddressValidationSchema = yup.object().shape(PropertyAddressValidationRuleObject) as any